export default "__VITE_ASSET__tm_ZizOd__"